export default {
    intro: 'Hãy nghe và viết chính xác nhé!',
    wordIndex: 'Từ thứ {index}',
    student: {
        myAnswer: 'Đáp án tôi đã nộp', noAnswer: 'Chưa có đáp án nào được nộp.', answer: 'Đáp án',
        attemptNumber: 'Lần {number}',
        listen: 'Hãy lắng nghe nhé!<br />Hãy tập trung nghe!',
        teacherReading: 'Giáo viên đang đọc trực tiếp',
        listenDirect: 'Hãy lắng nghe câu mà Giáo viên đang đọc trực tiếp nhé!',
        placeholder: 'Hãy nhập đáp án.', wrongToast: 'Ồ, sai rồi. Hãy nhập lại nhé',
        writeEnd: 'Kết thúc viết', submitAnswer: 'Nộp đáp án',
        waitingStart: 'Hãy chờ tín hiệu bắt đầu viết của Giáo viên!',
        threeWrong: 'Bạn đã sử dụng hết 3 cơ hội trả lời... Hãy chờ Giáo viên công bố đáp án nhé!',
    },
    teacher: {
        setting: {
            activity: 'Nội dung hoạt động', number: 'Số thứ tự', title: 'Chính tả 📝',
            message: 'Nếu phát câu này, Học sinh cũng có thể nghe thấy!',
            subMessage: 'Vẫn muốn phát không?',
            optionSubMessage: 'Sau khi phát một lần, cửa sổ xác nhận sẽ không xuất hiện nữa.',
            confirmText: 'Phát',
        },
        question: 'Câu hỏi', intro: 'Vui lòng chọn từ trong câu hỏi bên trái.',
        ttsStart: 'Phát rồi bắt đầu viết', directReading: 'Đọc trực tiếp',
        startWriting: 'Bắt đầu viết', completeWriting: 'Hoàn thành viết và công bố đáp án',
        toast: {
            alreadyDone: 'Đây là từ đã được thực hiện.',
            fiveSeconds: 'Có thể hoàn thành viết sau 5 giây kể từ khi bắt đầu viết.',
        },
        result: { title: 'Độ chính xác theo câu hỏi', order: 'Thứ tự', question: 'Câu hỏi', answerRate: 'Độ chính xác' },
    },
    table: { question: 'Câu hỏi', answerRate: 'Độ chính xác', emptyMessage: 'Không có nội dung.' },
};
